import { render, staticRenderFns } from "./ScreenPaged.vue?vue&type=template&id=53beb309&scoped=true"
import script from "./ScreenPaged.vue?vue&type=script&lang=js"
export * from "./ScreenPaged.vue?vue&type=script&lang=js"
import style0 from "./ScreenPaged.vue?vue&type=style&index=0&id=53beb309&prod&lang=css"
import style1 from "./ScreenPaged.vue?vue&type=style&index=1&id=53beb309&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53beb309",
  null
  
)

export default component.exports